import type { RBACGroup } from '../../../types';
import { useQueryErrorToast } from '../../graph/hooks/useQueryErrorToast';
import { useGetGroupMembersQuery } from '../../graph/services/graphApi';

import UserListPanel from './UserListPanel';

type Props = {
  role: RBACGroup;
};

// The role's assigned users. Add via autocomplete over the tenant; remove with the
// X (staged, not committed). Pending adds render green at the top, pending deletes
// red, mirroring the Users page's RoleGroupList. Shares UserListPanel with OwnersPanel.
export default function MembersPanel({ role }: Props) {
  const { data: members, isError } = useGetGroupMembersQuery(role.id);
  useQueryErrorToast(isError, 'Failed to load members');

  return (
    <UserListPanel
      bucket="members"
      title="Members"
      placeholder="Add a member"
      emptyLabel="No members."
      items={members}
      fill
    />
  );
}
